import React from "react";
import DashboardTranslationsWeekly from "./DashboardTranslationsWeekly";

const DashboardV2TranslationsWeekly = ({ user }) => (
  <DashboardTranslationsWeekly user={user} />
);

export default DashboardV2TranslationsWeekly;
